export const state = {
}
export const mutations = {
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/sessionModules/sessionMutation.js